import React, { useState, useEffect } from 'react';

const TypedText = ({ 
  text, 
  speed = 100, 
  onComplete = () => {}, 
  className = '',
  cursorColor = 'white' 
}) => {
  const [displayedText, setDisplayedText] = useState('');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showCursor, setShowCursor] = useState(true);

  // Handle the typing animation
  useEffect(() => {
    if (currentIndex < text.length) {
      const typingTimer = setTimeout(() => {
        setDisplayedText(prev => prev + text[currentIndex]);
        setCurrentIndex(prev => prev + 1);
      }, speed);
      
      return () => clearTimeout(typingTimer);
    } else {
      onComplete();
      
      // Continue cursor blinking after typing is complete
      const cursorTimer = setInterval(() => {
        setShowCursor(prev => !prev);
      }, 500);
      
      return () => clearInterval(cursorTimer);
    }
  }, [currentIndex, text, speed, onComplete]);

  // Custom styles with cursor
  const typedTextStyle = {
    position: 'relative',
    display: 'inline-block',
  };
  
  const cursorStyle = {
    display: showCursor ? 'inline-block' : 'none',
    marginLeft: '2px',
    height: '1em',
    width: '3px',
    backgroundColor: cursorColor,
    animation: 'blink 1s step-end infinite',
    verticalAlign: 'text-bottom',
  };

  return (
    <span className={className} style={typedTextStyle}>
      {displayedText}
      <span style={cursorStyle}></span>
    </span>
  );
};

export default TypedText; 